import React, { useContext, useEffect, useState } from 'react'
import './nav.scss'
import Button from '../Button/Button'
import { Link } from 'gatsby'
import {navigate} from 'gatsby'
import { IdentityContext } from '../../contexts/IdentityContext'
import { CgProfile } from 'react-icons/cg'

export default function Navbar() {
  const {user, setUser, setStoData, stoData} = useContext(IdentityContext);
  const [mobileMenuActive, setMobileMenuActive] = useState(false);
  const [userMenuActive, setUserMenuActive] = useState(false);
  const [navLinks,setNavLinks] = useState(null); 
  const [accountLink, setAccountLink] = useState("");
  useEffect(() => {
    const ownerMenu = [
      {
        name: "Home",
        link: "/portal/owner",
      },
      {
        name: "Garage",
        link: "/portal/owner/garage",
      },
      {
        name: "Service Locations",
        link: "/portal/owner/service-locations",
      },
      {
        name: "Help & Support",
        link: "/portal/owner/help-support",
      },
    ]; 

    const dealerMenu = [
      {
        name: "Home",
        link: "/portal/dealer",
      },
      {
        name: "Cases",
        link: "/portal/dealer/cases",
      },
      {
        name: "Warranty Registration",
        link: "/portal/dealer/warranty-registration",
      },
      {
        name: "Help & Support",
        link: "/portal/dealer/help-support",
      },
    ];
    if (user) {
      if (user.user_metadata.sto_type === "Owner") {
        setNavLinks(ownerMenu);
        setAccountLink("/portal/owner/account");
      } else if (user.user_metadata.sto_type === "Dealer" || user.user_metadata.sto_type === "Dealer-Employee") {
        setNavLinks(dealerMenu);
        setAccountLink("/portal/dealer/account");
      }
    }
  }, [user]);

  const mobileMenuToggle = () => {
    setUserMenuActive(false);
    setMobileMenuActive(!mobileMenuActive);
  };
  
  useEffect(() => {
    window.addEventListener("resize", function () {
      if (this.innerWidth > 1024 && mobileMenuActive) {
        setMobileMenuActive(false);
      }
    });
  })
    
   

  const userMenuToggle = () => {
    setMobileMenuActive(false);
    setUserMenuActive(!userMenuActive);
  }
  useEffect(() => {
    if (userMenuActive) {
      document.querySelector("#my-account-link").focus();
    } 
  }, [userMenuActive]);
  //logout user 
  const handleLogout = (e) => {
    e.preventDefault();
    mobileMenuToggle();
    userMenuToggle();
    user
      .logout()
      .then(response => {
        console.log('user logged out')
        navigate("/login");
        setUser('');
        setStoData('');
      })
      .catch(error => {
        console.log('error, not logged out')
        throw error
      })
  }

  

  function activeLink( {isCurrent} ) {
      return isCurrent ? {className: "nav-link active"} : {className: "nav-link"}
  }
  
  return (
    <nav className="main-nav">
      <div className="nav-grid">
        {/* mobile nav */}
        <ul className={`mobile-nav-links ${mobileMenuActive ? "active" : ""}`}>
          {stoData ? (
            <>
              {navLinks &&
                navLinks.map((item) => (
                  <li className="nav-item" key={item.name}>
                    <Link
                      to={item.link}
                      getProps={activeLink}
                      onClick={mobileMenuToggle}
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
            </>
          ) : (
            <>
              <li className="nav-item" key="Login">
                <Button
                  link="/login"
                  onClick={mobileMenuToggle}
                  text="Login"
                  styles="secondary"
                />
              </li>
              <li className="nav-item" key="Sign up">
                <Button
                  link="/signup"
                  text="Sign up"
                  onClick={mobileMenuToggle}
                  styles="primary"
                />
              </li>
            </>
          )}
        </ul>
        <div className="nav-col left">
          <a href="https://www.storytelleroverland.com/" className="site-logo">
            <img
              src="/assets/sto_retro_v_logo.svg"
              className="site-logo-desktop"
              alt="Storyteller Overland logo"
            />
            <img
              src="/assets/sto_logo_mobile.svg"
              className="site-logo-mobile"
              alt="Storyteller Overland logo"
            />
          </a>
        </div>
        <div className="nav-col center"></div>
        <div className="nav-col right">
          <ul className="nav-links">
            {stoData && (
              <>
                {navLinks &&
                  navLinks.map((item) => (
                    <li className="nav-item" key={item.name}>
                      <Link
                        to={item.link}
                        getProps={activeLink}
                        onClick={mobileMenuToggle}
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
              </>
            )}
          </ul>
          <button
            className={`mobile-nav-toggle ${mobileMenuActive ? "active" : ""}`}
            onClick={mobileMenuToggle}
          >
            <div className="toggle-line top"></div>
            <div className="toggle-line center"></div>
            <div className="toggle-line bottom"></div>
          </button>
          {user ? (
            <>
              {stoData && (
                <button
                  className="user-menu"
                  aria-label="User Menu"
                  onClick={(e) => {
                    e.preventDefault();
                    userMenuToggle();
                  }}
                >
                  <div className="user-menu-toggle">
                    <span className="user-menu-toggle-initial">
                      {stoData.firstname ? (
                        <>
                          {`${stoData.firstname.charAt(
                            0
                          )}${stoData.lastname?.charAt(0)}`}
                        </>
                      ) : stoData.company_name && !stoData.firstname ? (
                        stoData.company_name.charAt(0)
                      ) : (
                        <CgProfile className="user-menu-toggle__icon" />
                      )}
                    </span>
                  </div>
                  <div
                    className={`user-menu-options ${
                      userMenuActive ? "active" : ""
                    }`}
                    aria-modal="true"

                  >
                    <div className="user-menu-options-link">
                      <Link
                        to={accountLink}
                        id="my-account-link"
                        onClick={userMenuToggle}
                        tabIndex={userMenuActive ? `1` : `-1`}
                      >
                        My Account
                      </Link>
                    </div>
                    <div className="user-menu-options-link">
                      <a
                        href="/#"
                        onClick={handleLogout}
                        tabIndex={userMenuActive ? `2` : `-1`}
                      >
                        Log Out
                      </a>
                    </div>
                  </div>
                </button>
              )}
            </>
          ) : (
            <>
              <Button link="/login" text="Login" styles="secondary-yellow" />
              <Button link="/signup" text="Sign up" styles="yellow" />
            </>
          )}
        </div>
      </div>
    </nav>
  );
}